"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var core=require("@material-ui/core");let o=core.makeStyles(()=>({grid:{overflow:"hidden"},textOverflowTooltip:{overflow:"hidden",textOverflow:"ellipsis"}}));exports.default=o;
//# sourceMappingURL=styles.js.map
